<template>
  <div class="pl-page">

    <!-- Hero -->
    <div class="pl-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-tag-multiple-outline</v-icon>
        </v-avatar>
        <div>
          <div class="pl-hero__title">Promociones registradas</div>
          <div class="pl-hero__sub">Gestión y aprobación de promociones académicas</div>
        </div>
      </div>
      <div class="d-flex align-center" style="gap:8px;">
        <v-chip small color="rgba(255,255,255,0.15)" dark>
          <v-icon left small>mdi-school-outline</v-icon> Académico
        </v-chip>
        <v-btn small dark text @click="$router.back()">
          <v-icon left small>mdi-arrow-left</v-icon> Volver
        </v-btn>
      </div>
    </div>

    <div class="pl-body">

      <!-- Toolbar -->
      <v-card outlined class="pl-table-card">
        <div class="pl-table-toolbar px-4 py-2 d-flex align-center flex-wrap" style="gap:8px;">
          <v-chip x-small :color="promociones.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ promociones.length }} promoción{{ promociones.length !== 1 ? 'es' : '' }}
          </v-chip>
          <v-spacer />
          <v-progress-circular v-if="loading" indeterminate color="indigo" size="20" width="2" class="mr-2" />
          <v-btn
            v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
            color="indigo darken-1" dark depressed small
            @click="openmodal()">
            <v-icon left small>mdi-plus</v-icon> Registrar promoción
          </v-btn>
        </div>

        <v-divider />

        <v-data-table
          :headers="headers"
          :items="promociones"
          :items-per-page="50"
          :loading="loading"
          loading-text="Cargando promociones..."
          no-data-text="Sin promociones registradas."
          dense
          class="pl-table"
        >
          <!-- Aprobado por -->
          <template v-slot:[`item.aprobado_por`]="{ item }">
            <v-chip v-if="item.aprobado_por" x-small label color="green lighten-5" class="green--text text--darken-2">
              <v-icon left x-small>mdi-check-circle-outline</v-icon>
              {{ item.aprobado_por }}
            </v-chip>
            <v-chip v-else x-small label color="amber lighten-4" class="amber--text text--darken-3">
              <v-icon left x-small>mdi-clock-outline</v-icon>
              Pendiente
            </v-chip>
          </template>

          <!-- Acciones -->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex align-center" style="gap:4px;">
              <v-tooltip bottom v-if="item.inscritos != 0">
                <template #activator="{ on, attrs }">
                  <v-btn icon x-small color="orange darken-1" v-bind="attrs" v-on="on" @click="getviewp(item)">
                    <v-icon x-small>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Visualizar datos</span>
              </v-tooltip>

              <v-tooltip
                bottom
                v-if="item.inscritos != 0 && !item.aprobado_por && ($store.state.CARGO.id == 1 || $store.state.CARGO.id == 14)">
                <template #activator="{ on, attrs }">
                  <v-btn icon x-small color="green darken-1" v-bind="attrs" v-on="on" @click="preAprobacion(item)">
                    <v-icon x-small>mdi-clipboard-check-multiple</v-icon>
                  </v-btn>
                </template>
                <span>Aprobar promoción</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>

    </div>

    <Create ref="createmodal" v-on:onnew="onnew" />
    <Viewp ref="viewmodal" />
  </div>
</template>

<script>
  import Create from '@/views/promociones/promo-create.vue';
  import Viewp from '@/views/promociones/promo-view.vue';
  import { getdataeliminar, getdataaprobar } from '@/views/promociones/util.js';
  import xaxios from '@/xaxios';

  export default {
    data: () => ({
      loading: false,
      promociones: [],
      posgrado: null,
      headers: [
        { text: 'ID',               value: 'id',           width: 60 },
        { text: 'Nombre promoción', value: 'nombre' },
        { text: 'Creado por',       value: 'creado_por',   width: 140 },
        { text: 'Aprobado por',     value: 'aprobado_por', width: 180 },
        { text: 'Fecha inicio',     value: 'fecha_inicio', width: 120 },
        { text: 'Fecha final',      value: 'fecha_fin',    width: 120 },
        { text: 'Acciones',         value: 'actions',      width: 90,  sortable: false },
      ],
    }),
    components: { Create, Viewp },
    methods: {
      openmodal() {
        window.console.log(this.$refs);
        this.$refs.createmodal.openmodal();
      },
      onnew() {
        this.getpromos();
      },
      getviewp(item) {
        this.$refs.viewmodal.openmodal(item);
      },
      getpromos() {
        this.loading = true;
        let vue = this;
        this.promociones = [];
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones`,
          headers: {},
        };
        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log(data);
            vue.promociones = data.reverse();
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
      preAprobacion(item) {
        let vue = this;
        let dat = getdataaprobar();
        this.$dialog
          .confirm(dat.message, dat.options)
          .then(function(dialog) {
            vue.eliminar(item, dialog);
          })
          .catch(function() {});
      },
      preEliminacion() {
        let vue = this;
        let dat = getdataeliminar();
        this.$dialog
          .confirm(dat.message, dat.options)
          .then(function(dialog) {
            vue.loadingediting = true;
            dialog.close();
          })
          .catch(function() {});
      },
      eliminar(item, dialog) {
        let vue = this;
        let us = this.$store.state.DATA_USER;
        if (!us.seg_apellido) us.seg_apellido = '';
        let usuario = `${us.nombres} ${us.pri_apellido} ${us.seg_apellido}`.trim();
        var config = {
          method: 'patch',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones`,
          headers: {},
          data: { id: item.id, aprobado_por: usuario },
        };
        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log(data);
            vue.getpromos();
            dialog.close();
          })
          .catch(function(error) {
            window.console.log(error);
            dialog.close();
          });
      },
    },
    mounted() {
      this.getpromos();
    },
  };
</script>

<style scoped>
.pl-page { min-height: 100vh; background: #f5f7fa; }

.pl-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.pl-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.pl-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.pl-body { padding: 20px 24px; }

.pl-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.pl-table-toolbar { background: #fafbff; border-bottom: 1px solid #e8edf7; }

.pl-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.pl-table >>> tbody tr:hover { background: #f0f4ff !important; }
.pl-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 4px 12px !important;
}
</style>
